/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 14:50:37
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-06 09:36:31
 */
import { Component, OnInit, Input } from '@angular/core';
import { FooterOption } from './model';

@Component({
  selector: 'ad-section-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input()
  option: FooterOption;

  constructor() {}

  ngOnInit(): void {}
}
